/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpiringLeaseTerms
 */
export interface ExpiringLeaseTerms {
    /**
     * 
     * @type {number}
     * @memberof ExpiringLeaseTerms
     */
    inSixMonths: number;
    /**
     * 
     * @type {number}
     * @memberof ExpiringLeaseTerms
     */
    inOneYear: number;
    /**
     * 
     * @type {number}
     * @memberof ExpiringLeaseTerms
     */
    inTwoYears: number;
}

/**
 * Check if a given object implements the ExpiringLeaseTerms interface.
 */
export function instanceOfExpiringLeaseTerms(value: object): value is ExpiringLeaseTerms {
    if (!('inSixMonths' in value) || value['inSixMonths'] === undefined) return false;
    if (!('inOneYear' in value) || value['inOneYear'] === undefined) return false;
    if (!('inTwoYears' in value) || value['inTwoYears'] === undefined) return false;
    return true;
}

export function ExpiringLeaseTermsFromJSON(json: any): ExpiringLeaseTerms {
    return ExpiringLeaseTermsFromJSONTyped(json, false);
}

export function ExpiringLeaseTermsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpiringLeaseTerms {
    if (json == null) {
        return json;
    }
    return {
        
        'inSixMonths': json['inSixMonths'],
        'inOneYear': json['inOneYear'],
        'inTwoYears': json['inTwoYears'],
    };
}

export function ExpiringLeaseTermsToJSON(json: any): ExpiringLeaseTerms {
    return ExpiringLeaseTermsToJSONTyped(json, false);
}

export function ExpiringLeaseTermsToJSONTyped(value?: ExpiringLeaseTerms | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inSixMonths': value['inSixMonths'],
        'inOneYear': value['inOneYear'],
        'inTwoYears': value['inTwoYears'],
    };
}

